var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('material-card',{attrs:{"color":"primary","title":_vm.$t('profile'),"full-width":""}},[_c('UserInfoFormDialog',{attrs:{"hideTitle":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }